const state = {
  isCollapse: false,
  // tagsViews
  visitedViews: [
    {
      path: "/dashborad",
      title: "首页",
      name: "Dashborad",
      fullPath: "/dashborad",
    },
  ], // 在 tagsviews 中使用 遍历渲染 tags
  cachedViews: [], // 在 appmain 中的 keepalive 中使用 维护 缓存
};

const mutations = {
  SET_COLLAPSE(state, value) {
    state.isCollapse = !state.isCollapse;
  },
  ADD_VISITED_VIEW(state, view) {
    if (state.visitedViews.some((v) => v.fullPath === view.fullPath)) return;

    let title = ''
    if(view.meta.title.indexOf("详情") && view.query.id && view.query.title){
      title = view.query.title + "-" + view.meta.title + "-" + view.query.id
    }else if(view.meta.title.indexOf("详情") && view.query.id){
      title = view.meta.title + "-" + view.query.id
    }else{
      title = view.meta.title || "no-name";
    }
    if(view.meta.title == '完成情况总览' && view.query.round){
      title = view.meta.title + "-" + view.query.id + "-"+ view.query.round
    }
      // (view.meta.title.indexOf("详情") && view.query.id
      //   ? view.query.title + "-" + view.meta.title + "-" + view.query.id
      //   : view.meta.title) || "no-name";

    state.visitedViews.push(
      Object.assign({}, view, {
        title,
      })
    );
  },
  ADD_CACHED_VIEW(state, view) {
    if (state.cachedViews.includes(view.name)) return;
    if (!view.meta.noCache) {
      state.cachedViews.push(view.name);
    }
  },
  DEL_VISITED_VIEW(state, view) {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path === view.path) {
        state.visitedViews.splice(i, 1);
        break;
      }
    }
  },
  DEL_CACHED_VIEW(state, view) {
    const index = state.cachedViews.indexOf(view.name);
    index > -1 && state.cachedViews.splice(index, 1);
  },

  DEL_OTHERS_VISITED_VIEWS(state, view) {
    state.visitedViews = state.visitedViews.filter((item) => {
      return item.path === "/dashborad" || item.path === view.path;
    });
  },
  DEL_OTHERS_CACHED_VIEWS(state, view) {
    const index = state.cachedViews.indexOf(view.name);
    if (index > -1) {
      state.cachedViews = state.cachedViews.slice(index, index + 1);
    } else {
      state.cachedViews = [];
    }
  },
  DEL_ALL_VISITED_VIEWS(state) {
    state.visitedViews = state.visitedViews.filter(
      (item) => item.path === "/dashborad"
    );
  },
  DEL_ALL_CACHED_VIEWS(state) {
    state.cachedViews = [];
  },
};

const actions = {
  addView({ dispatch }, view) {
    dispatch("addVisitedView", view);
    dispatch("addCachedView", view);
  },
  addVisitedView({ commit }, view) {
    commit("ADD_VISITED_VIEW", view);
  },
  addCachedView({ commit }, view) {
    commit("ADD_CACHED_VIEW", view);
  },
  delView({ dispatch, state }, view) {
    return new Promise((resolve) => {
      dispatch("delVisitedView", view);
      dispatch("delCachedView", view);
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews],
      });
    });
  },
  delVisitedView({ commit, state }, view) {
    return new Promise((resolve) => {
      commit("DEL_VISITED_VIEW", view);
      resolve([...state.visitedViews]);
    });
  },
  delCachedView({ commit, state }, view) {
    return new Promise((resolve) => {
      commit("DEL_CACHED_VIEW", view);
      resolve([...state.cachedViews]);
    });
  },

  delOthersViews({ dispatch, state }, view) {
    return new Promise((resolve) => {
      dispatch("delOthersVisitedViews", view);
      dispatch("delOthersCachedViews", view);
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews],
      });
    });
  },
  delOthersVisitedViews({ commit, state }, view) {
    return new Promise((resolve) => {
      commit("DEL_OTHERS_VISITED_VIEWS", view);
      resolve([...state.visitedViews]);
    });
  },
  delOthersCachedViews({ commit, state }, view) {
    return new Promise((resolve) => {
      commit("DEL_OTHERS_CACHED_VIEWS", view);
      resolve([...state.cachedViews]);
    });
  },
  delAllViews({ dispatch, state }, view) {
    return new Promise((resolve) => {
      dispatch("delAllVisitedViews", view);
      dispatch("delAllCachedViews", view);
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews],
      });
    });
  },
  delAllVisitedViews({ commit, state }) {
    return new Promise((resolve) => {
      commit("DEL_ALL_VISITED_VIEWS");
      resolve([...state.visitedViews]);
    });
  },
  delAllCachedViews({ commit, state }) {
    return new Promise((resolve) => {
      commit("DEL_ALL_CACHED_VIEWS");
      resolve([...state.cachedViews]);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
